(() => {
  const root = document.getElementById('iq-root');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const strings = JSON.parse(document.getElementById('iq-strings').textContent);
  const productDialog = document.getElementById('iq-product-dialog');
  const selectionDialog = document.getElementById('iq-selection-dialog');
  const mode = document.getElementById('iq-mode');
  let catalog = [], selected = new Map(), current = null, imageIndex = 0;
  let catalogPromise;
  const text = (tag, value, className) => {
    const el = document.createElement(tag);
    el.textContent = value;
    if (className) el.className = className;
    return el;
  };
  const getCatalog = () => catalogPromise ||= fetch(root.dataset.catalog).then(r => {
    if (!r.ok) throw new Error('Catalog request failed');
    return r.json();
  }).then(data => catalog = data).catch(error => {
    catalogPromise = null;
    throw error;
  });
  const setMode = value => {
    mode.value = value;
    document.querySelectorAll('.iq-business-field,.iq-wholesale-field,.iq-drop-field').forEach(el => {
      const visible = el.classList.contains('iq-business-field') ? value !== 'retail' : el.classList.contains('iq-wholesale-field') ? value === 'wholesale' : value === 'dropshipping';
      el.hidden = !visible;
      el.querySelectorAll('input').forEach(input => {
        input.disabled = !visible;
        input.required = visible && ['iq-company', 'iq-quantity'].includes(input.id);
      });
    });
  };
  const renderSelection = () => {
    const list = document.getElementById('iq-selection-items');
    const summary = document.getElementById('iq-form-selection');
    list.replaceChildren(); summary.replaceChildren();
    document.querySelectorAll('[data-count]').forEach(el => el.textContent = selected.size);
    if (!selected.size) { list.append(text('p', strings.empty)); summary.append(text('p', strings.empty)); }
    selected.forEach((quantity, id) => {
      const p = catalog.find(p => p.id === id);
      if (!p) return;
      const row = text('div', '', 'iq-selection-row');
      const image = document.createElement('img');
      image.src = p.images[0].url + '&width=150'; image.alt = p.images[0].alt; image.width=65; image.height=75;
      const info = document.createElement('div'); info.append(text('h3', p.title));
      const remove = text('button', strings.remove, 'iq-remove'); remove.type='button';
      remove.addEventListener('click', () => { selected.delete(id); renderSelection(); });
      info.append(remove);
      const label = text('label', strings.selection_qty);
      const input = document.createElement('input'); input.type='number'; input.min='1'; input.step='1'; input.value=quantity;
      input.setAttribute('aria-label', `${strings.selection_qty}: ${p.title}`);
      input.addEventListener('change', () => { selected.set(id, Math.max(1, Math.floor(Number(input.value)||1))); renderSelection(); });
      label.append(input); row.append(image,info,label);list.append(row);
      summary.append(text('p', `${p.title} × ${quantity}`, 'iq-form-item'));
    });
    document.getElementById('iq-selected-input').value = [...selected].map(([id,q]) => `${catalog.find(p=>p.id===id)?.title} [${id}] × ${q}`).join('\n');
    document.querySelectorAll('[data-add]').forEach(button => {
      const active = selected.has(button.dataset.add); button.textContent=active?'✓':'+';button.setAttribute('aria-pressed',String(active));
    });
  };
  const showImage = index => {
    if (!current) return;
    imageIndex=(index+current.images.length)%current.images.length;
    const image=current.images[imageIndex];
    const large=document.getElementById('iq-detail-image');large.src=image.url+'&width=1000';large.alt=image.alt;
    document.querySelectorAll('#iq-thumbs button').forEach((el,i)=>{el.classList.toggle('is-active',i===imageIndex);el.setAttribute('aria-pressed',String(i===imageIndex));});
  };
  const openProduct = async id => {
    await getCatalog();
    current=catalog.find(p=>p.id===id); if(!current)return;
    document.getElementById('iq-product-title').textContent=current.title;
    document.getElementById('iq-product-description').textContent=current.description || strings.detail_text;
    document.getElementById('iq-product-purchasing').textContent=current.purchasing || '';
    document.getElementById('iq-product-code').textContent=`STYLE / ${current.id}`;
    document.getElementById('iq-camera-stock').hidden=current.title!=='Camera crossbody bag';
    const thumbs=document.getElementById('iq-thumbs');thumbs.replaceChildren();
    current.images.forEach((image,i)=>{
      const button=document.createElement('button');button.type='button';button.setAttribute('aria-label',`${strings.thumb} ${i+1}: ${image.alt}`);
      const img=document.createElement('img');img.src=image.url+'&width=110';img.alt='';img.loading='lazy';img.width=52;img.height=56;
      button.append(img);button.addEventListener('click',()=>showImage(i));thumbs.append(button);
    });
    showImage(0);productDialog.showModal();
  };
  root.addEventListener('click', async event => {
    const button=event.target.closest('[data-product],[data-add],[data-open-selection],[data-close],[data-mode]');
    if(!button)return;
    if(button.dataset.mode)setMode(button.dataset.mode);
    if(button.hasAttribute('data-close'))button.closest('dialog').close();
    if(button.hasAttribute('data-open-selection')){await getCatalog();renderSelection();selectionDialog.showModal();}
    if(button.dataset.product){await openProduct(button.dataset.product);}
    if(button.dataset.add){await getCatalog();const id=button.dataset.add;selected.has(id)?selected.delete(id):selected.set(id,1);renderSelection();}
  });
  [productDialog,selectionDialog].forEach(dialog=>dialog.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}}));
  document.querySelector('[data-prev]').addEventListener('click',()=>showImage(imageIndex-1));
  document.querySelector('[data-next]').addEventListener('click',()=>showImage(imageIndex+1));
  document.getElementById('iq-retail-product').addEventListener('click',()=>{
    selected.clear();selected.set(current.id,1);renderSelection();setMode('retail');productDialog.close();location.hash='enquiry';
  });
  document.getElementById('iq-add-product').addEventListener('click',()=>{
    selected.set(current.id,selected.get(current.id)||1);renderSelection();setMode('wholesale');productDialog.close();selectionDialog.showModal();
  });
  document.getElementById('iq-selection-continue').addEventListener('click',()=>{
    selectionDialog.close();if(mode.value==='retail'&&selected.size>1)setMode('wholesale');location.hash='enquiry';
  });
  mode.addEventListener('change',()=>setMode(mode.value));
  let activeFilter='All';
  const filter=()=>{
    const query=document.getElementById('iq-search').value.trim().toLowerCase();let count=0;
    document.querySelectorAll('.iq-card').forEach(card=>{card.hidden=!(activeFilter==='All'||card.dataset.category===activeFilter)||!card.dataset.title.includes(query);if(!card.hidden)count++;});
    document.getElementById('iq-result-count').textContent=count;document.getElementById('iq-no-results').hidden=count!==0;
  };
  document.querySelectorAll('[data-filter]').forEach(button=>button.addEventListener('click',()=>{
    activeFilter=button.dataset.filter;document.querySelectorAll('[data-filter]').forEach(b=>b.classList.toggle('is-active',b===button));filter();
  }));
  document.getElementById('iq-search').addEventListener('input',filter);
  setMode('retail');
  if(new URLSearchParams(location.search).get('contact_posted')==='true')document.getElementById('enquiry').scrollIntoView();
})();

